import React from 'react';
import {Card} from "@mui/material";
import {isNotNull} from "../../util/Validators";

import DEFAULT_PORTRAIT from "../../images/portrait.png";
import "../../App.css";
import "./Speaker.css";

export default function Speaker(props) {

    const name = props.name;
    // const field = props.field;
    // const company = props.company;
    // const degrees = props.degrees;
    const bio = props.bio;
    const portrait = isNotNull(props.portrait) ? props.portrait : DEFAULT_PORTRAIT;

    return (
        <React.Fragment>

            <div
                className={"speaker-div"}
            >
                <div style={{
                    marginLeft: "20px",
                    marginRight: "20px",
                }}>
                    <Card>
                        <div style={{
                            width: "280px",
                            height: "280px",
                            margin: "auto",
                            paddingTop: "20px"
                        }}>
                            <img src={portrait} alt={"Speaker Portrait"} width={"100%"}/>
                        </div>
                        <div
                            className={"default-font-color-dark default-font-huge default-font-bold"}
                            style={{
                                paddingBottom: "20px",
                                marginTop: "5px"
                            }}
                        >
                            {name}
                        </div>
                    </Card>
                    <div
                        style={{
                            border: "solid 1px white",
                            padding: "20px"
                        }}
                    >
                        {bio}
                    </div>
                </div>

            </div>

        </React.Fragment>
    )
}